import "./Causes.css";
import {
  Eye,
  Edit2,
  Trash2,
  MapPin,
  Users,
  Clock,
  AlertCircle,
  TrendingUp,
  Heart,
  Shield,
} from "lucide-react";
import { useEffect, useState } from "react";
import { reordercauselist } from "../../services/mainService";
import { useNavigate } from "react-router-dom";

const Reordercause = () => {
  const [causes, setcauses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setpagination] = useState({
    current_page: 1,
    per_page: 10,
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchcause();
  }, []);
  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };
  const calculatePercentage = (raised, goal) => {
    return Math.min(Math.round((raised / goal) * 100), 100);
  };

  const fetchcause = async () => {
    try {
      const res = await reordercauselist({ page: pagination.current_page });
      console.log(res);

      setcauses(res.data);
      setpagination(res?.pagination_info);
    } catch (err) {
      console.error("Error fetching causes:", err);
    } finally {
    }
  };

  return (
    <div className="allcause-page">
      <header className="page-header warning">
        <h2>Reorder Causes</h2>
        <p>Causes that are live and available for donations</p>
      </header>

      {!causes || causes.length === 0 ? (
        <div className="empty-state">
          <Shield size={64} />
          <h3>No causes found</h3>
        </div>
      ) : (
        <>
          <div className="allcause_card_grid">
            {causes?.map((cause, index) => (
              <div
                key={cause.id}
                className="allcause_card"
                style={{ "--card-index": index }}
              >
                {/* Card Header with Image */}
                <div className="card-header">
                  <img
                    src={cause.image}
                    alt={cause.title}
                    className="card-image"
                    loading="lazy"
                  />
                  <div className="card-overlay"></div>

                  {/* Status Badge */}
                  <span className={`status-badge approved`}>
                    {cause.status.charAt(0).toUpperCase() +
                      cause.status.slice(1)}
                  </span>

                  {/* Priority Badge */}
                  {cause.highPriority && (
                    <div className="priority-badge">
                      <AlertCircle size={12} />
                      High Priority
                    </div>
                  )}
                </div>

                {/* Card Content */}
                <div className="card-content">
                  {/* Title and Category */}
                  <h3 className="card-title">{cause.title}</h3>
                  <div className="card-description">{cause.description}</div>

                  {/* Meta Information */}
                  <div className="card-meta">
                    <div className="meta-item">
                      <Users size={14} />
                      <span>{cause.category}</span>
                    </div>
                    <div className="meta-item">
                      <MapPin size={14} />
                      <span>
                        {cause.district} {cause.state}
                      </span>{" "}
                    </div>
                    <div className="meta-item">
                      <Heart size={14} />
                      <span>{cause.donors} donors</span>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="progress-section">
                    <div className="progress-header">
                      <div className="raised-amount">
                        {formatAmount(cause.amount_collected)}
                        <span>raised</span>
                      </div>
                      <div className="goal-amount">
                        Goal: {formatAmount(cause.amount_required)}
                      </div>
                    </div>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{
                          width: `${calculatePercentage(cause.amount_collected, cause.amount_required)}%`,
                        }}
                      ></div>
                    </div>
                    <div className="progress-info">
                      <span className="percentage">
                        {calculatePercentage(
                          cause.amount_collected,
                          cause.amount_required,
                        )}
                        % funded
                      </span>
                      {/* <span className="time-left">
                        <Clock size={14} />
                        {cause.daysLeft} days left
                      </span> */}
                    </div>
                  </div>

                  {/* Card Footer */}
                  <div className="card-footer">
                    {/* <div className="creator-info">
                      <img
                        src={`https://ui-avatars.com/api/?name=${cause.createdBy}&background=2E8B57&color=fff`}
                        alt={cause.createdBy}
                        className="creator-avatar"
                      />
                      <div className="creator-details">
                        <h4>{cause.createdBy}</h4>
                        <p>Organizer</p>
                      </div>
                    </div> */}

                    <div className="time-left">
                      <Clock size={14} />
                      {cause.end_date}expires
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                  <button
                    className="action-btn view"
                    title="View Details"
                    onClick={() => navigate("/cause-details", { state: cause })}
                  >
                    <Eye size={18} />
                  </button>
                  {/* <button className="action-btn edit" title="Edit">
                    <Edit2 size={18} />
                  </button>
                  <button className="action-btn delete" title="Delete">
                    <Trash2 size={18} />
                  </button> */}
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="pagination">
            <button className="page-btn prev">
              <TrendingUp size={16} />
              Previous
            </button>
            <button className="page-btn active">1</button>
            <button className="page-btn">2</button>
            <button className="page-btn">3</button>
            <span className="page-dots">...</span>
            <button className="page-btn">8</button>
            <button className="page-btn next">
              Next
              <TrendingUp size={16} />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Reordercause;
